import { Helmet } from "react-helmet-async";
import { buildSocialMeta } from "../seo/openGraph";

/**
 * Page-level social tags. New landing pages pick this up by rendering <Seo>
 * (LandingPage already does). Crawler-visible copies are written at build time
 * from the same buildSocialMeta() output.
 */
export default function Seo(props) {
  const meta = buildSocialMeta(props);
  return (
    <Helmet>
      <title>{meta.title}</title>
      <meta name="description" content={meta.description} />
      <link rel="canonical" href={meta.url} />
      <meta property="og:title" content={meta.title} />
      <meta property="og:description" content={meta.ogDescription} />
      <meta property="og:type" content={meta.type} />
      <meta property="og:url" content={meta.url} />
      <meta property="og:image" content={meta.image} />
      <meta property="og:image:secure_url" content={meta.image} />
      <meta property="og:image:type" content={meta.imageType} />
      {meta.imageWidth && meta.imageHeight ? (
        <meta property="og:image:width" content={String(meta.imageWidth)} />
      ) : null}
      {meta.imageWidth && meta.imageHeight ? (
        <meta property="og:image:height" content={String(meta.imageHeight)} />
      ) : null}
      <meta property="og:image:alt" content={meta.imageAlt} />
      <meta property="og:site_name" content="Maxiom Apps" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={meta.title} />
      <meta name="twitter:description" content={meta.ogDescription} />
      <meta name="twitter:image" content={meta.image} />
      <meta name="twitter:image:alt" content={meta.imageAlt} />
      {meta.keywords ? <meta name="keywords" content={meta.keywords} /> : null}
      {meta.robots ? <meta name="robots" content={meta.robots} /> : null}
    </Helmet>
  );
}
